import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95dcd818"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row gx-5" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-5" }, "What you want and have already", -1))
const _hoisted_5 = { class: "card text-dark bg-light mb-5 rounded-4 border-0" }
const _hoisted_6 = { class: "card-body p-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-4 pb-2 border-bottom" }, " The income you want ", -1))
const _hoisted_8 = { class: "card text-dark bg-light mb-5 rounded-4 border-0" }
const _hoisted_9 = { class: "card-body p-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-4 pb-2 border-bottom" }, " Benefits from current scheme ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "This pension will increase as per the scheme rules.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card text-dark bg-light mb-5 rounded-4 border-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body p-4" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "mb-4 pb-2 border-bottom" }, " State pension scheme benefits "),
    /*#__PURE__*/_createElementVNode("p", null, "We have assumed you will get a full State Pension from State Pension Age.")
  ])
], -1))
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-5" }, "What else can you put towards retirement?", -1))
const _hoisted_15 = { class: "card text-dark bg-light mb-5 rounded-4 border-0" }
const _hoisted_16 = { class: "card-body p-4" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-4 pb-2 border-bottom" }, " Any other final salary pensions you may have ", -1))
const _hoisted_18 = { class: "card text-dark bg-light mb-5 rounded-4 border-0" }
const _hoisted_19 = { class: "card-body p-4" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-4 pb-2 border-bottom" }, " Any pension pots you may have ", -1))
const _hoisted_21 = { class: "card text-dark bg-light mb-5 rounded-4 border-0" }
const _hoisted_22 = { class: "card-body p-4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-4 pb-2 border-bottom" }, " Any savings/ISAs you may have ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 mx-auto" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mb-4" }, "Calculation"),
  /*#__PURE__*/_createElementVNode("p", null, " OK - we are now going to see if it's very likely that you can get what you want just by using your current scheme benefits, rather than needing to consider if transferring these may provide it. ")
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "col-md-6 mx-auto" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-4" }, "Calculation outcome", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "",
    "data-bs-toggle": "modal",
    "data-bs-target": "#assumptionsModal"
  }, "See disclaimer and assumptions used in these calculations")
], -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "progress-bar progress-bar-striped progress-bar-animated",
    role: "progressbar",
    "aria-valuenow": "75",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    style: {"width":"75%"}
  }, " Calculating financial position... ")
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "It seems very likely", -1))
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "It does not seem very likely", -1))
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<div class=\"modal fade\" id=\"assumptionsModal\" tabindex=\"-1\" aria-labelledby=\"assumptionsModalLabel\" aria-hidden=\"true\" data-v-95dcd818><div class=\"modal-dialog modal-lg modal-dialog-centered\" data-v-95dcd818><div class=\"modal-content\" data-v-95dcd818><div class=\"modal-header bg-primary text-white\" data-v-95dcd818><h5 class=\"modal-title\" id=\"assumptionsModalLabel\" data-v-95dcd818> Assumptions </h5><button type=\"button\" class=\"btn-close btn-close-white\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-95dcd818></button></div><div class=\"modal-body\" data-v-95dcd818><h5 data-v-95dcd818>Disclaimer</h5><p data-v-95dcd818> These calculations are indicative. They are guidance and are not intended as advice in any form. Their sole purpose is to provide a high level indication, given the assumptions used and information provided, of whether it may be possible to achieve the retirement income you require, using what you currently have </p><ul data-v-95dcd818><li data-v-95dcd818> We assume you will start taking benefits in around 6 months time </li><li data-v-95dcd818> Where you have not provided a reduced pension plus cash figure, we estimate the reduced pension as 75% of the full pension and the cash amount as 15 times the amount of pension given up. The actual cash available from your scheme may vary from this assumption depending on the scheme rules. </li><li data-v-95dcd818> Any debts you want to pay will be removed from the tax free cash figure before being used to provide a retirement income </li><li data-v-95dcd818> Future growth rates on any tax free cash, savings and pension pots are assumed to be 2.5% a year after any provider charges </li><li data-v-95dcd818> If you have stated you will require additional advice we have reduced this to 2.0% a year after charges to meet additional advice costs of 0.5% a year </li><li data-v-95dcd818> We have assumed inflation is 2.5% a year and the State Pension will increase at 2.5% a year </li><li data-v-95dcd818> We have proportioned the State Pension approximately given the number of years of National Insurance contributions provided </li><li data-v-95dcd818> Where you have indicated your scheme pension mainly increases we have used an estimate of 2.5% a year increases </li><li data-v-95dcd818> On any additional pension pots, we have assumed 25% tax free cash is not taken at outset and you will use the whole pots towards your retirement income </li><li data-v-95dcd818> On any other final salary pensions input, we have assumed that these will increase at 2.5% each year </li><li data-v-95dcd818> We have used English tax rates and bands to estimate tax payable when calculating the after tax income required </li></ul></div></div></div></div>", 1)
const _hoisted_37 = {
  id: "buttonContainer",
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pot_list = _resolveComponent("pot-list")!
  const _component_nav_buttons = _resolveComponent("nav-buttons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("p", null, _toDisplayString(_ctx.getStartingIncomeStatement), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentSchemeDescriptions, (item) => {
                  return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                }), 128))
              ]),
              _hoisted_11
            ])
          ]),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_pot_list, {
                ref: "definedBenefitPots",
                assetType: "definedBenefit",
                assetName: "Final Salary Income",
                addLabel: "Add a different final salary income",
                potFactory: _ctx.finalSalaryPotFactory,
                currentValueLabel: "Starting income",
                capturePayableFrom: true
              }, null, 8, ["potFactory"])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_pot_list, {
                ref: "pensionPots",
                assetType: "pensions",
                assetName: "Pension Pot",
                addLabel: "Add pension pot",
                potFactory: _ctx.pensionPotFactory
              }, null, 8, ["potFactory"])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_pot_list, {
                ref: "savingsPots",
                assetType: "savings",
                assetName: "Savings Pots",
                addLabel: "Add saving pot",
                potFactory: _ctx.savingPotFactory
              }, null, 8, ["potFactory"])
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.showWhatYouHave]
    ]),
    _withDirectives(_createElementVNode("div", null, _hoisted_25, 512), [
      [_vShow, _ctx.showPreCalcMessage]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _hoisted_28,
        (!_ctx.hasFinancialDeficitCalcCompleted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
          : _createCommentVNode("", true),
        (_ctx.hasFinancialDeficitCalcCompleted)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!_ctx.hasFinancialDeficit)
                ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                    _hoisted_33,
                    _createTextVNode(" that you can get the income you want, by just using what you have already in the scheme and elsewhere. ")
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_34, [
                    _hoisted_35,
                    _createTextVNode(" that you can get the income you want, by just using what you have already in the scheme and elsewhere. ")
                  ]))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, _ctx.showAnswers]
    ]),
    _hoisted_36,
    _createElementVNode("div", _hoisted_37, [
      _createVNode(_component_nav_buttons, {
        previousVisible: _ctx.showPreviousButton,
        onPreviousClicked: _ctx.onPreviousClicked,
        onNextClicked: _ctx.onNextClicked
      }, null, 8, ["previousVisible", "onPreviousClicked", "onNextClicked"])
    ])
  ]))
}